import { useSnakeCase } from 'dashboard/composables/useTransformKeys';

// The task a conversation bubble announces, as its message payload carries it
// (CardTasks::MessagePayload), in the shape the API answers with, so the bubble draws its final block
// before the task is read. MessageList camelizes every message deeply, the keys of the answers and
// of the status names included, so they are snake-cased back first.
export const taskFromPayload = card => {
  const payload = useSnakeCase(card, { deep: true });
  return {
    id: payload.task_id,
    card_id: payload.card_id,
    system_key: payload.type_system_key,
    title: payload.name,
    type_icon: payload.type_icon,
    status: payload.status,
    // A bubble written before the payload carried every name knows only the current one.
    status_labels: payload.status_labels || {
      [payload.status]: payload.status_label,
    },
    assignee: payload.assignee || null,
    due_at: payload.due_at || null,
    done_at: payload.done_at || null,
    created_at: payload.requested_at,
    data: payload.form_data || {},
    fields: payload.fields || [],
    visit: payload.visit || null,
  };
};
